<template>
  <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
    <h4 style="margin-bottom: 0;">Danh sách thi lại</h4>
    <el-button type="success" class="text-white" @click="openRegistrationTypeDialog">
      <i class="el-icon-plus text-white"></i> <span>Đăng ký thi lại</span>
    </el-button>

    <el-dialog
      title="Vui lòng chọn mục đăng ký thi lại"
      :show-close="false"
      :visible.sync="showRegistrationTypeDialog"
      width="30%"
    >
      <div class="registration-type-options">
        <el-radio v-model="registrationType" label="entrance">Thi đầu khóa</el-radio>
        <el-radio v-model="registrationType" label="regular">Giữa khóa &amp; Cuối khóa</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="button-cancel" @click="showRegistrationTypeDialog = false">Đóng</el-button>
        <el-button type="primary" :disabled="!registrationType" @click="confirmRegistrationType">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Đăng ký thi lại cho học viên" :show-close="false" :visible.sync="createExamSchedule"
               v-if="createExamSchedule" width="50%">
      <hr style="padding: 0; margin-top: -20px"/>
      <FormRetest @closeDialog="closeRetestDialog" @getListRetest="getListRetest"/>
    </el-dialog>

    <el-dialog title="Đăng ký thi lại cho học viên" :show-close="false" :visible.sync="createEntranceExamSchedule"
               v-if="createEntranceExamSchedule" width="50%">
      <hr style="padding: 0; margin-top: -20px"/>
      <FormEntranceRetest @closeDialog="closeEntranceRetestDialog" @getListRetest="getListRetest"/>
    </el-dialog>
  </div>
</template>

<script>

import FormRetest from "./FormRetest.vue";
import FormEntranceRetest from "./FormEntranceRetest.vue";

export default {
  name: 'HeaderManageRetest',
  components: {FormEntranceRetest, FormRetest},
  data() {
    return {
      createExamSchedule: false,
      createEntranceExamSchedule: false,
      showRegistrationTypeDialog: false,
      registrationType: null,
      isLoading: false,
      form: {
        user_id: null,
        classroom_id: null,
        course_id: null,
        exam_date: null,
        exam_time: null,
        retest_count: null,
        skills: [],
      },
    }
  },
  mounted() {
  },
  methods: {
    openRegistrationTypeDialog() {
      this.registrationType = null
      this.showRegistrationTypeDialog = true
    },
    confirmRegistrationType() {
      if (!this.registrationType) return
      this.showRegistrationTypeDialog = false
      if (this.registrationType === 'entrance') {
        this.createEntranceExamSchedule = true
        return
      }
      this.createExamSchedule = true
    },
    closeRetestDialog() {
      this.createExamSchedule = false
      this.registrationType = null
    },
    closeEntranceRetestDialog() {
      this.createEntranceExamSchedule = false
      this.registrationType = null
    },
    getListRetest(){
      this.$emit('getListRetest')
    }
  },
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.button-cancel {
  background: #CACACA;
  color: black;
}

.button-cancel:hover {
  color: white;
  opacity: 90%;
}

.registration-type-options {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
